import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import FilePptOutlinedSvg from "@ant-design/icons-svg/es/asn/FilePptOutlined";
import AntdIcon from "../components/AntdIcon";
var FilePptOutlined = function FilePptOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FilePptOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  FilePptOutlined.displayName = 'FilePptOutlined';
}
export default /*#__PURE__*/React.forwardRef(FilePptOutlined);